import { Input, Modal, ModalBody } from "reactstrap"
import PrimaryButton from "../../../../../../components/common/PrimaryButton/PrimaryButton"
import styles from "./EditUserRoleModal.module.scss"
import CustomDropdown from "../../../../../../components/common/Dropdown/CustomDropDown"

const EditUserRoleModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "430px",
          maxWidth: "460px",
        }}
      >
        <ModalBody>
          <div className="text-center">
            <div className="my-3 fw-medium fs-4">Edit User Role</div>
          </div>

          <div className="d-flex flex-column gap-2">
            <div>
              <div className={styles.label}>Name</div>
              <div>
                <Input value={"Lorem ipsum"} />
              </div>
            </div>
            <div>
              <div className={styles.label}>Email</div>
              <div>
                <Input value={"Loremipsum@gmail.com"} />
              </div>
            </div>
            <div>
              <div className={styles.label}>Password</div>
              <div>
                <Input value={"DT2456G"} />
              </div>
            </div>
            <div>
              <div className={styles.label}>Role</div>
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title={"Inventory Manager"} />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-center mt-3">
            <PrimaryButton name="Save Changes" />
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default EditUserRoleModal
